import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StatisticTypeEnum } from 'src/app/enum/statistic-type.enum';
import { CustomerService } from 'src/app/services/customer.service';
import { DatasService } from 'src/app/services/datas.service';
import {
  FILTER_NAME,
  getChildrenApplicationsFromParentContext,
  getParentApplicationFromContext,
  searchApplication,
} from 'src/app/services/helpers/app-context-helper';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { StatisticService } from 'src/app/services/statistic.service';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';

@Component({
  selector: 'ng-configurators-2d-selection',
  templateUrl: './configurators-2d-selection.component.html',
})
export class Configurator2DSelectionComponent implements OnInit {
  parentApp;
  children;

  constructor(
    public customer: CustomerService,
    private router: Router,
    public datas: DatasService,
    private readonly statistic: StatisticService,
    private readonly tunnelDataStore: TunnelDataStore
  ) {}

  ngOnInit(): void {
    this.parentApp = getParentApplicationFromContext(this.customer.context);
    this.children = getChildrenApplicationsFromParentContext(this.parentApp.distribID);
    this.children = this.children.filter(c => this.datas.isAppEnabled(c.distribID));
  }

  startNewConfiguration(context: string) {
    this.tunnelDataStore.resetState(false);
    this.customer.context = context;
    let app = searchApplication(context, FILTER_NAME.DISTRIB_ID);
    try {
      this.sendNewProjectCountStatistic(context);
    } catch (error) {
      logError("Erreur lors de l'envoi des statistiques à COM+ :", error);
    }
    this.router.navigateByUrl('/' + this.parentApp.routeUrl + '/' + app.routeUrl + '/configuration');
  }

  sendNewProjectCountStatistic(context) {
    this.statistic.sendStatistic(StatisticTypeEnum.NEW_PROJECT_CLICKED_COUNT, 1, context);
  }
}
